module.exports = __webpack_public_path__ + "img/img2.a072d824.jpg";